import { Box, Card, Grid, Typography } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import { toggleMeterAction } from "meter/meter.actions";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { IApplicationState } from "redux/root-reducer";
import { StatusIndicator } from "safetySensors/components/statusIndicator";
import { IMeterObject } from "../types";
import { TwoFactorStepper } from "./2Factor/twoFactorStepper";
import { AlertDialog } from "../../common/components/AlertDialog";
import styles from "./meterItem.module.scss";
import {
  EventType,
  getDeviceAlertDescription,
} from "safetySensors/deviceAlerts";

interface IMeterItemProps {
  domain: string;
  meterObject: IMeterObject;
  phoneNumbers: string[];
}
export const MeterItem = ({
  domain,
  meterObject,
  phoneNumbers,
}: IMeterItemProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [twoFactorOpen, setTwoFactorOpen] = useState<boolean>(false);
  const [alertDialogOpen, setalertDialogOpen] = useState<boolean>(false);

  const openMeters = useSelector(
    (state: IApplicationState) => state.meters.meters
  ).filter((m) => m.Status);

  const handleTwoFactorClose = (success?: boolean) => {
    if (success) {
      openMeters.length >= 1 ? setalertDialogOpen(true) : onToggle(true);
      setTwoFactorOpen(false);
    }
    setTwoFactorOpen(false);
  };

  const onToggle = (checked: boolean) => {
    dispatch(toggleMeterAction(domain, meterObject, checked));
  };

  const alertClose = (activatecallback: boolean) => {
    activatecallback && onToggle(true);
    setalertDialogOpen(false);
  };

  const toggleMonitoring = (checked: boolean) => {
    if (!phoneNumbers.length) {
      setTwoFactorOpen(true);
      return;
    }

    if (checked && openMeters.length >= 1) {
      setalertDialogOpen(true);
      return;
    }

    onToggle(checked);
  };
  const isActiveAlarm = meterObject.EventTypeID !== EventType.Alarm;

  return (
    <>
      <Card className={styles.button}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography color="primary" variant="caption">
            {meterObject.Name}
          </Typography>
          <Switch
            checked={meterObject.Monitoring}
            size="small"
            color="secondary"
            onChange={(e) => toggleMonitoring(e.target.checked)}
          />
        </Box>
        <StatusIndicator
          status={
            isActiveAlarm ? "warning" : meterObject.Status ? "warning" : "ok"
          }
          text={
            isActiveAlarm
              ? getDeviceAlertDescription(meterObject.EventTypeID)
              : meterObject.Status
              ? t("Open")
              : t("Closed")
          }
        />
      </Card>
      <TwoFactorStepper open={twoFactorOpen} onClose={handleTwoFactorClose} />
      <AlertDialog
        open={alertDialogOpen}
        onClose={alertClose}
        activateTitle={t("Activate shell protection")}
        openNodes={openMeters
          .filter((m) => m.Status)
          .map((m) => `${m.Name} ${t("is open!")}`)}
      />
    </>
  );
};
